import dummy from '../../common/dummy';
import Utils from '../../common/utils';
import Const from '../../common/const';
import AbstractHandler from './abstract-handler';

class Handler extends AbstractHandler {
    constructor() {
        super();
    }

    doSearchEvents = (dummyFunc: any, param: any) => {
        return Utils.asyncSleep(500)
            .then(() => {
                return  dummy.EVENTS_LIST({ param })
            })
            .then((res) => {
                return res.data.body;
            }
        );
    }

    getReverseGeocoder = (path: string, latLng: any) => {
        return this.getRequest(path, latLng).then((res: any) => {
            if (res.result !== Const.API_RESULT.OK) {
                throw new Error(JSON.stringify({ msg: `処理NG`, error: res.err }));
            } else {
                return res.response;
            }
        });
    }
}

export default Handler;